import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { ReactElement, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { primary } from '@/theme/colors';

export type Props = {
  diameter?: number;
  icon?: ReactElement<'svg'>;
  text: string | JSX.Element;
  actionButton?: JSX.Element;
  backgroundColor?: string;
  textColor?: string;
};

const defaultDiameter = 500;

export const FeedbackCircle = ({
  diameter,
  icon,
  text,
  actionButton,
  backgroundColor = 'rgba(101, 130, 164, 0.05)',
  textColor = primary.light,
}: Props) => {
  const calcDiameter = useMemo(() => {
    return diameter || defaultDiameter;
  }, [diameter]);

  const contentSize = useMemo(() => {
    return (calcDiameter / 2) * Math.SQRT2;
  }, [calcDiameter]);

  const action = useMemo(() => {
    return actionButton || undefined;
  }, [actionButton]);

  const calcIcon = useMemo(() => {
    return icon || <TableChartOutlinedIcon sx={{ color: primary.light, fontSize: '8rem' }} />;
  }, [icon]);

  return (
    <Box
      sx={{
        width: `${calcDiameter / 10}rem`,
        height: `${calcDiameter / 10}rem`,
        borderRadius: '50%',
        backgroundColor,
      }}
    >
      <Box
        sx={{
          width: contentSize,
          height: contentSize,
          m: '0 auto',
          position: 'relative',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          sx={{ height: '100%' }}
        >
          <>{calcIcon}</>
          <Typography color={textColor} fontSize="1.8rem" align="center">
            {text}
          </Typography>
          {action}
        </Stack>
      </Box>
    </Box>
  );
};
